import React from 'react';
import StaffCommissions from '../components/StaffCommissions';
import { useBusinessStore } from '../store/useBusinessStore';

export default function CommissionsPage() {
  const { masterDb, activeBusinessId, setMasterDb } = useBusinessStore();
  const activeBusiness = masterDb.find(b => String(b.id) === String(activeBusinessId));

  if (!activeBusiness) return <div>Cargando...</div>;

  const handleUpdateBusiness = (updatedBusiness) => {
    setMasterDb(prev => prev.map(b => {
      if (String(b.id) === String(updatedBusiness.id)) {
        return { ...b, ...updatedBusiness };
      }
      return b;
    }));
  };

  return (
    <StaffCommissions
      activeBusiness={activeBusiness}
      onUpdateBusiness={handleUpdateBusiness}
    />
  );
}
